export const SELECTED_MAP_LAYERS = 'SELECTED_MAP_LAYERS';
export const SELECTED_MAP_STYLE = 'SELECTED_MAP_STYLE';
export const RECENT_SEARCHES = 'RECENT_SEARCHES';
export const DETAIL_PANE_SIZE = 'DETAIL_PANE_SIZE';
export const LS_LAST_UPDATED_VERSION = 'LAST_UPDATED_VERSION';
